import type { UseQueryExecute } from "urql"

import { useAssociatedTestTemplateColumns } from "./useAssociatedTestTemplateColumns"

import { useGetAssociatedTestTemplateList } from "."

import type { AssociatedTestTemplate } from "@/graphql/codegen/graphql"

export interface UseAssociatedTestTemplatesTableReturn {
  associatedTestTemplates: AssociatedTestTemplate[]
  columns: ReturnType<typeof useAssociatedTestTemplateColumns>
  isFetching: boolean
  refetch: UseQueryExecute
}
export const useAssociatedTestTemplatesTable = (productId: number): UseAssociatedTestTemplatesTableReturn => {
  const { associatedTestTemplates, isFetching, refetch } = useGetAssociatedTestTemplateList({
    productId,
  })

  const columns = useAssociatedTestTemplateColumns(refetch)

  return {
    associatedTestTemplates,
    columns,
    isFetching,
    refetch,
  }
}
